import produce from 'immer';
import {
  GET_STORE_CATEGORIES_START,
  GET_STORE_CATEGORIES_SUCCESS,
  GET_STORE_CATEGORIES_FAILED,
  GET_STORE_CATEGORIES_TREE_START,
  GET_STORE_CATEGORIES_TREE_SUCCESS,
  GET_STORE_CATEGORIES_TREE_FAILED,
  CHANGE_STORE_CATEGORY_VALUE,
  CANCEL_ALL_STORE_CATEGORIES_CHANGES,
  SAVE_STORE_CATEGORY_START,
  SAVE_STORE_CATEGORY_SUCCESS,
  SAVE_STORE_CATEGORY_FAILED,
  CREATE_STORE_CATEGORY_START,
  CREATE_STORE_CATEGORY_SUCCESS,
  CREATE_STORE_CATEGORY_FAILED,
  CHANGE_HOMEPAGE_CATEGORY_VALUE,
  CHANGE_PRODUCT_CATEGORY_STATUS
} from '../actions/categories';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  storeCategories: [],
  storeCategoriesTree: [],
  storeActiveCategories: [],
  storeActiveCategoriesWithActiveNavLevel: [],
  storeActiveCategoriesWithAllActiveParents: [],
  storeCategoriesWithActiveNavLevel: [],
  unchangeableStoreCategoriesTree: [],
  updatedStoreCategories: {},
  updatedHomepageCategories: {},
  failedStoreCategories: [],
  isNewCategory: false,
  loadingCategories: false,
  errorCategories: false,
  loadingStoreCategoriesTree: false,
  errorStoreCategoriesTree: false,
  loadingSaveStoreCategories: false,
  loadingCreateStoreCategory: false
};

const formReducer = produce((state: ICategoriesState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_CATEGORIES_START: {
      state.errorCategories = false;
      state.loadingCategories = true;
      break;
    }

    case GET_STORE_CATEGORIES_SUCCESS: {
      const {data} = action;

      const navLevelActiveCategoriesIds = data.items.filter((category) => (
        category.is_active && category.level == 2
      )).map((c) => c.id);

      state.storeCategories = data.items;
      state.storeActiveCategories = data.items.filter((cat) => cat.is_active);

      state.storeActiveCategoriesWithActiveNavLevel = data.items.filter((cat) => (
        cat.is_active &&
        navLevelActiveCategoriesIds.some((id) => `/${cat.path}/`.includes(`/${id}/`))
      ));

      state.storeCategoriesWithActiveNavLevel = data.items.filter((cat) => (
        navLevelActiveCategoriesIds.some((id) => `/${cat.path}/`.includes(`/${id}/`))
      ));


      const activeCategoryIds = data.items
        .filter((category) => category.is_active)
        .map((category) => category.id);

      const isCategoryWithActiveParents = (category) => {
        if (category.id === 1) {
          return true;
        }

        const pathIds = category.path.split('/').filter((id) => id !== '');

        for (let i = 0; i < pathIds.length; i++) {
          const parentId = parseInt(pathIds[i]);

          if (parentId === 1) {
            continue;
          }

          if (!activeCategoryIds.includes(parentId)) {
            return false;
          }
        }

        return true;
      };

      state.storeActiveCategoriesWithAllActiveParents = data.items.filter((category) => isCategoryWithActiveParents(category));

      state.errorCategories = false;
      state.loadingCategories = false;

      break;
    }

    case GET_STORE_CATEGORIES_FAILED: {
      state.errorCategories = true;
      state.loadingCategories = false;
      break;
    }

    case GET_STORE_CATEGORIES_TREE_START: {
      state.errorStoreCategoriesTree = false;
      state.loadingStoreCategoriesTree = true;
      break;
    }
    case GET_STORE_CATEGORIES_TREE_SUCCESS: {
      const {data} = action;

      state.storeCategoriesTree = [data];
      state.unchangeableStoreCategoriesTree = [data];
      state.errorStoreCategoriesTree = false;
      state.loadingStoreCategoriesTree = false;

      break;
    }
    case GET_STORE_CATEGORIES_TREE_FAILED: {
      state.errorStoreCategoriesTree = true;
      state.loadingStoreCategoriesTree = false;
      break;
    }
    case CHANGE_STORE_CATEGORY_VALUE: {
      const { categoryId, name, value } = action;

      const findCategory = (category) => {
        category?.forEach((item) => {
          if (item.id !== categoryId && item.children_data.length !== 0) {
            findCategory(item.children_data);
          }

          if (item.id === categoryId) {
            item[name] = value;

            if (name === 'is_active') {
              item['include_in_menu'] = value;
            }
          }
        });
      };

      findCategory(state.storeCategoriesTree);

      if (state.updatedStoreCategories[categoryId]) {
        name === 'is_active' ? state.updatedStoreCategories[categoryId] = {...state.updatedStoreCategories[categoryId], [name]: value, include_in_menu: value}
          : state.updatedStoreCategories[categoryId] = {...state.updatedStoreCategories[categoryId], [name]: value};
      } else {
        name === 'is_active' ?
          state.updatedStoreCategories = {
            ...state.updatedStoreCategories,
            [categoryId]: {
              ...state.updatedStoreCategories[categoryId],
              id: categoryId,
              [name]: value,
              include_in_menu: value
            }
          }
          : state.updatedStoreCategories = {
            ...state.updatedStoreCategories,
            [categoryId]: {
              ...state.updatedStoreCategories[categoryId],
              id: categoryId,
              [name]: value
            }
          };
      }

      break;
    }
    case CHANGE_HOMEPAGE_CATEGORY_VALUE: {
      const { categoryId, name, value } = action;
      let changedCategory: ICategory;

      if (state.updatedHomepageCategories[categoryId]) {
        changedCategory = {...state.updatedHomepageCategories[categoryId], [name]: value};
      } else {
        changedCategory = {
          ...state.updatedHomepageCategories[categoryId],
          id: categoryId,
          [name]: value,
        };
      }

      // update product description according to name
      if (name === 'name') {
        if (!changedCategory.custom_attributes) {
          changedCategory.custom_attributes = [{ attribute_code: 'description', value: `<h1>${value}</h1>`}];
        } else {
          const descriptionExist = changedCategory.custom_attributes.find((a) => a.attribute_code === 'description');

          if (descriptionExist) {
            changedCategory.custom_attributes = changedCategory.custom_attributes.map((a) =>  a.attribute_code === 'description' ? ({ attribute_code: 'description', value: `<h1>${value}</h1>`}) : a);
          } else {
            changedCategory.custom_attributes = [...changedCategory.custom_attributes, { attribute_code: 'description', value: `<h1>${value}</h1>`}];
          }
        }
      }

      state.updatedHomepageCategories[categoryId] = changedCategory;

      break;
    }

    case CANCEL_ALL_STORE_CATEGORIES_CHANGES: {
      state.storeCategoriesTree = state.unchangeableStoreCategoriesTree;
      state.updatedStoreCategories = {};
      break;
    }

    case SAVE_STORE_CATEGORY_START: {
      state.loadingSaveStoreCategories = true;
      break;
    }

    case SAVE_STORE_CATEGORY_SUCCESS: {
      state.failedStoreCategories = [];
      state.updatedStoreCategories = {};
      state.loadingSaveStoreCategories = false;

      break;
    }

    case SAVE_STORE_CATEGORY_FAILED: {
      const {category} = action;
      state.loadingSaveStoreCategories = false;
      state.failedStoreCategories = [...state.failedStoreCategories, category];
      break;
    }

    case CREATE_STORE_CATEGORY_START: {
      state.loadingCreateStoreCategory = true;
      break;
    }

    case CREATE_STORE_CATEGORY_SUCCESS: {
      const {data} = action;
      state.isNewCategory = data;
      const parentIds = data.path.split('/').filter((i) => i > 2);

      const nameWithPath = parentIds.map((id) => {
        const parent = state.storeCategories.find((category) => category.id == id);

        if (parent && parent.name) {
          return parent.name.trim();
        }

        return data.name.trim();
      });

      state.storeCategories = [
        ...state.storeCategories,
        {...data, nameWithPath: nameWithPath.join(' ▸ '), is_active: true}]
        .sort((a, b) => a.nameWithPath.localeCompare(b.nameWithPath));

      state.storeActiveCategories = state.storeCategories.filter((cat) => cat.is_active);

      const navLevelActiveCategoriesIds = state.storeCategories.filter((category) => (
        category.is_active && category.level == 2
      )).map((c) => c.id);

      state.storeActiveCategoriesWithActiveNavLevel = state.storeCategories.filter((cat) => (
        cat.is_active &&
        navLevelActiveCategoriesIds.some((id) => `/${cat.path}/`.includes(`/${id}/`))
      ));

      state.storeCategoriesWithActiveNavLevel = state.storeCategories.filter((cat) => (
        navLevelActiveCategoriesIds.some((id) => `/${cat.path}/`.includes(`/${id}/`))
      ));
      state.loadingCreateStoreCategory = false;

      break;
    }

    case CREATE_STORE_CATEGORY_FAILED: {
      state.loadingCreateStoreCategory = false;
      break;
    }

    case CHANGE_PRODUCT_CATEGORY_STATUS: {
      const {categoryId} = action;

      state.storeCategories = state.storeCategories.map((category) => (
        category.id == categoryId
          ? {...category, is_active: true}
          : category
      ));

      state.storeActiveCategories = state.storeCategories.filter((cat) => cat.is_active);

      const navLevelActiveCategoriesIds = state.storeCategories.filter((category) => (
        category.is_active && category.level == 2
      )).map((c) => c.id);

      state.storeActiveCategoriesWithActiveNavLevel = state.storeCategories.filter((cat) => (
        cat.is_active &&
        navLevelActiveCategoriesIds.some((id) => `/${cat.path}/`.includes(`/${id}/`))
      ));

      state.storeCategoriesWithActiveNavLevel = state.storeCategories.filter((cat) => (
        navLevelActiveCategoriesIds.some((id) => `/${cat.path}/`.includes(`/${id}/`))
      ));
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.storeCategoriesTree = initialState.storeCategoriesTree;
      state.unchangeableStoreCategoriesTree = initialState.unchangeableStoreCategoriesTree;
      state.storeActiveCategoriesWithActiveNavLevel = initialState.storeActiveCategoriesWithActiveNavLevel;
      state.storeActiveCategoriesWithAllActiveParents = initialState.storeActiveCategoriesWithAllActiveParents;
      state.storeCategories = initialState.storeCategories;

      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
